import React from "react";
import "../reelcraft/reelcraft.css";
import NewFooter from "../../components/NewFooter/NewFooter";
import { Carousel } from "../../components/VerticalCarousel";
import img6 from "../../assets/products/car1.png";
import img7 from "../../assets/products/car2.png";
import img8 from "../../assets/products/car3.png";
import img9 from "../../assets/products/car4.jpg";

import b1 from "../../assets/products/output-onlinepngtools.png";
import b2 from "../../assets/products/output-onlinepngtools (2).png";
import b3 from "../../assets/products/output-onlinepngtools (1).png";
import CardGrid from "../../components/productCardsGrid/productInfoCards";

export default function ContentEye() {

const cards = [
  {
    title: "Agentic AI Integration",
    description:
      "Autonomous AI agents manage content validation, enrichment, optimisation, and compliance while retaining human oversight for high-stakes editorial decisions."
  },
  {
    title: "Monetisation & Compliance",
    description:
      "Transforms media assets into governed, monetisable entities with built-in compliance, privacy safeguards, consent tracking, and intelligent ad placement."
  },
  {
    title: "Content Quality Check Solution",
    description:
      "An AI-powered quality validation layer that detects technical, audio, visual, and editorial issues while generating actionable compliance insights."
  },
  {
    title: "MediaLake Backbone",
    description:
      "A cloud-native, serverless AI platform backbone enabling scalable ingestion, metadata enrichment, governance, search, and workflow orchestration."
  }
];



  const whitepapers = [
    {
      id: 1,
      src: img6,
      alt: "image1 for carousel",
    },
    {
      id: 2,
      src: img7,
      alt: "image 2 for carousel",
    },
    {
      id: 3,
      src: img8,
      alt: "image 3 for carousel",
    },
        {
      id: 4,
      src: img9,
      alt: "image 4 for carousel",
    },
  ];

const blogs = [
  {
    id: "1",
    title: "AI-Driven Optimisation & Governance",
    description:
      "Maximise ROI through intelligent AI-powered optimisation, automated governance, and oversight mechanisms while retaining full human editorial control.",
    name: "",
    image: b1,
  },
  {
    id: "2",
    title: "Cloud-Native Scalability & Operations",
    description:
      "Leverage cloud-native architecture to scale effortlessly, streamline operations, reduce costs, and accelerate end-to-end content workflows.",
    name: "",
    image: b2,
  },
  {
    id: "3",
    title: "Enhanced Discoverability & Engagement",
    description:
      "Improve content discoverability and audience engagement across every channel with intelligent distribution, optimisation, and compliance-ready delivery.",
    name: "",
    image: b3,
  },
];


  const BlogCard = ({ title, description, name, image }) => (
    <div className="sara-styled-card">
      <img className="overlay-image" src={image} alt={title} style={{borderRadius:"20px !important"}}/>
      <div className="card-content">
        <h5 className="title">{title}</h5>
        <p className="description">{description}</p>
        {/* <p className="author">Author: {name}</p> */}
      </div>
    </div>
  );

  return (
    <div style={{background: "black"}}>
      <div className="sara-container" >
        <div className="sara-first">
          <div className="logo">
            <img src={require("../../assets/nsara/f2576786-dfec-449f-9b0b-b820983d0f0d-removebg-preview.png")} alt="ContentEye Logo" />
          </div>
          <div className="sara-title">
            <h3>Content Eye</h3>
          </div>
          <div className="sara-des">
            <p>
             Content Eye is Horizon’s flagship content intelligence platform designed to transform unstructured media into actionable insight at scale. Built for modern broadcasters and media enterprises, it ingests video, audio, image, and document assets and applies deep, multimodal AI analysis to generate standardised technical metadata, frame-level intelligence, and compliance indicators. Using secure, serverless, event-driven cloud workflows, Content Eye automates media transfer and analysis while enabling real-time object, face, and scene detection, semantic understanding, and evolving metadata creation—unlocking precise search, faster editorial validation, and deeper contextual discovery across massive content archives.</p>
          </div>
          <div className="img-section">
            {blogs.map((blog, index) => (
              <BlogCard key={index} {...blog} />
            ))}
          </div>
        </div>
        <div className="insight">
          <div className="sara1-carousel" >
            <Carousel data={whitepapers} />
            <div className="cus-des">
              <div className="cus-title">
                <h3>Content Eye</h3>
<p>Horizon Content Eye is a cloud-agnostic content intelligence platform that combines deep multimodal AI with enterprise-grade reliability.</p>

<p>It transforms how organisations analyse and manage video, audio, images, and documents at scale.</p>

<p>The platform enables smarter content understanding, improved compliance, and faster discovery across large media libraries.</p>

<p>By converting complex media into actionable intelligence, Content Eye helps businesses drive efficiency, insight, and sustainable growth.</p>


                
              </div>
            </div>
          </div>
        </div>

        <div className="w-m-s-p">
          <div className="sara-title2">
            <h3>What makes Content Eye Special</h3>
          </div>
          
      <CardGrid cards={cards}/>
          
        </div>
       
      </div>
       <NewFooter />
    </div>
  );
}
